module.exports = __webpack_public_path__ + "static/img/test-healthy-life.9858330.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reproductive/test-healthy-life.jpg
// module id = 627Z
// module chunks = 0